import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { List, Divider, Typography } from 'antd'

import { formateDate } from '../../utils/dateUtil'
import { req_single_bulletinBoard } from '../../api'
import { API_BASE } from '../../utils/contrains'
const { Text } = Typography;

class DetailsBulletinboardModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////

    static propTypes = {
        bulletinboard: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        item: {}
    }

    // constructor(props) {
    //     super(props)
    // }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.api_single_item()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_single_item = async () => {
        const { token } = this.props.user
        const { uid } = this.props.bulletinboard
        this.setState({ loading: true })
        const result = await req_single_bulletinBoard(uid, token)
        this.setState({ loading: false })
        const item = result
        this.setState({ item })
    }

    /////////////////////////////////////////////////////////// 


    /////////////////////////////////////////////////////////// 
    render() {
        const {publishDateTime, msgAuthorName, msgTitle, msgContent, attacheFileUrl } = this.state.item
        const downloadUrl = API_BASE + attacheFileUrl
        return (
            <>
                <List>
                    <List.Item>
                        <Divider orientation="left" style={{ borderColor: '#7cb305' }} dashed><i className="fas fa-clipboard-list"></i>{' '}公告資訊{' '}<Text mark>發布時間：{formateDate(publishDateTime)}</Text></Divider>
                        發佈人： {msgAuthorName} <br />
                        公告主旨： {msgTitle} <br />
                        公告內容： <span dangerouslySetInnerHTML={{ __html: msgContent }} /> <br />
                        {attacheFileUrl === 'NA' || attacheFileUrl === '' ? '' : (<>檔案下載： <a href={downloadUrl} download="檔案下載" className='btn btn-link btn-sm'><i className="fas fa-cloud-download-alt"></i><span style={{ marginLeft: '4px' }}>下載</span></a></>)}
                    </List.Item>
                </List>
            </>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(DetailsBulletinboardModal)